/* eslint-disable max-len */
import React from 'react';

const EditIcon = props => (
  <svg width={19} viewBox="0 0 19 19" {...props}>
    <path d="M11.498 5.326L3 13.8V16h2.2l8.486-8.486-2.188-2.188zm.688-.687l2.199 2.176L16 5.2 13.83 3l-1.644 1.64zM2 13.523a.2.2 0 0 1 .059-.141l11.1-11.1a1 1 0 0 1 1.414 0l2.146 2.145a1 1 0 0 1 0 1.414l-11.1 11.1a.2.2 0 0 1-.142.059H2.2a.2.2 0 0 1-.2-.2v-3.277zM5 4h1.8c.11 0 .2.09.2.2v.6a.2.2 0 0 1-.2.2H5v1.8a.2.2 0 0 1-.2.2h-.6a.2.2 0 0 1-.2-.2V5H2.2a.2.2 0 0 1-.2-.2v-.6c0-.11.09-.2.2-.2H4V2.2c0-.11.09-.2.2-.2h.6c.11 0 .2.09.2.2V4z" />
  </svg>
);

export default EditIcon;
